import { fmtDate, euro, STATUS } from "@/lib/format";
import { MoveRight, Tag, Euro, Wallet, Trash2, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { downloadBlob } from "@/lib/download";

const ICONS = { move: MoveRight, status: Tag, price: Euro, payment_add: Wallet, payment_del: Trash2 };

const describe = (h, roomName) => {
  switch (h.type || "move") {
    case "status":
      return <>Stato: {STATUS[h.from]?.label || h.from} → <b>{STATUS[h.to]?.label || h.to}</b></>;
    case "price":
      return <>Prezzo: {euro(h.from)} → <b>{euro(h.to)}</b></>;
    case "payment_add":
      return <>Pagamento registrato: <b>{euro(h.amount)}</b>{h.method ? ` (${h.method})` : ""}</>;
    case "payment_del":
      return <>Pagamento eliminato: <b>{euro(h.amount)}</b>{h.method ? ` (${h.method})` : ""}</>;
    default:
      return (
        <>
          {h.from.room_id !== h.to.room_id && <span>{roomName(h.from.room_id)} → <b>{roomName(h.to.room_id)}</b> · </span>}
          {fmtDate(h.from.check_in)}–{fmtDate(h.from.check_out)} → <b>{fmtDate(h.to.check_in)}–{fmtDate(h.to.check_out)}</b>
        </>
      );
  }
};

export const HistoryPdfButton = ({ booking }) => (
  <Button variant="outline" size="sm" data-testid="history-pdf-button"
    onClick={() => downloadBlob(`/bookings/${booking.id}/history.pdf`, `cronologia_${(booking.guest_name || "prenotazione").replace(/\s+/g, "_")}.pdf`)}>
    <Download className="w-4 h-4 mr-1.5" />Scarica PDF
  </Button>
);

export const BookingHistory = ({ history, rooms }) => {
  if (!history?.length) return <p className="text-xs text-muted-foreground mt-4" data-testid="booking-history-empty">Nessuna modifica registrata.</p>;
  const roomName = (id) => rooms.find((r) => r.id === id)?.name || "—";
  return (
    <div className="mt-4" data-testid="booking-history">
      <p className="text-xs uppercase tracking-[0.15em] text-accent font-semibold mb-2">Cronologia modifiche</p>
      <ul className="space-y-2 max-h-56 overflow-y-auto text-xs pr-1">
        {[...history].reverse().map((h, i) => {
          const Icon = ICONS[h.type] || MoveRight;
          return (
            <li key={i} className="flex gap-2 border-l-2 border-accent/40 pl-3" data-testid={`history-entry-${i}`} data-history-type={h.type || "move"}>
              <Icon className="w-3.5 h-3.5 mt-0.5 text-accent shrink-0" />
              <div>
                <div className="text-muted-foreground">{new Date(h.at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })} · {h.user}</div>
                <div>{describe(h, roomName)}</div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
